<div [formGroup]="accountForm">
  <pseic-section [sectionTitle]="personalData">
    <div class="o-form-section">
      <div class="o-form-group u-width-250">
        <pseic-form-field
          label="Imię"
          labelFor="firstName"
          i18n-label="@@common.first_name"
          [component]="this"
        >
          <input
            class="o-form-field"
            id="firstName"
            type="text"
            [readonly]="readonly"
            formControlName="firstName"
            required
          >
        </pseic-form-field>
      </div>
      <div class="o-form-group u-width-250">
        <pseic-form-field
          label="Nazwisko"
          labelFor="lastName"
          i18n-label="@@common.last_name"
          [component]="this"
        >
          <input
            class="o-form-field"
            id="lastName"
            type="text"
            [readonly]="readonly"
            formControlName="lastName"
            required
          >
        </pseic-form-field>
      </div>
      <div class="o-form-group u-width-250">
        <pseic-form-field
          label="E-mail"
          labelFor="email"
          i18n-label="@@common.email"
          [component]="this"
        >
          <input
            class="o-form-field"
            id="email"
            type="text"
            [readonly]="readonly"
            formControlName="email"
            required
          >
        </pseic-form-field>
      </div>
    </div>
    <div class="o-form-group u-width-250">
      <pseic-form-field
        label="Aktualny poziom sprawdzenia tożsamości"
        labelFor="ial"
        i18n-label="@@common.ial"
        [component]="this"
      >
        <input
          class="o-form-field"
          id="ial"
          type="text"
          [readonly]="true"
          [value]="accountForm.controls?.ial?.value | multiLangDict"
        >
      </pseic-form-field>
    </div>
    <div class="o-form-group u-width-250">
      <pseic-form-field
        label="Oczekiwany poziom sprawdzenia tożsamości"
        labelFor="expectedIal"
        i18n-label="@@common.expected_ial"
        [disabled]="readonly"
      >
        <select
          class="o-form-select u-width-250"
          id="expectedIal"
          formControlName="expectedIal"
        >
          <option
            *ngFor="let ialOption of ialOptions"
            [selected]="accountForm.controls.expectedIal.value === ialOption.id"
            [value]="ialOption.id"
          >{{ialOption.name}}</option>
        </select>
      </pseic-form-field>
    </div>
  </pseic-section>
  <pseic-section [sectionTitle]="phoneNumber">
    <pseic-phone [phoneForm]="accountForm.get('phone')"></pseic-phone>
    <label class="o-form-check" for="sharePhone">
      <input
        class="o-form-check__input"
        type="checkbox"
        id="sharePhone"
        [disabled]="readonly"
        formControlName="sharePhone"
      >
      <span
        class="o-form-check__btn"
        i18n="@@account.share_phone"
      >
          Udostępnij nr telefonu Administratorom Bezpieczeństwa Partnera Biznesowego
      </span>
    </label>
  </pseic-section>
</div>
